import axios from 'axios';

import { ENV_VARS } from '@/env';

import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

export const getTransportationModeEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.PRIMARY}/GetTransportationMode`,
  });
};

export const getSpotQuoteTransportationModesEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SPOT_QUOTE_V2}/options/transportation-modes`,
  });
};

export const getCarrieStatusesEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SPOT_QUOTE_V2}/options/carrier-statuses`,
  });
};

export const getDocumentTypesEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.PRIMARY}/GetmoduleDocumentTypes`,
  });
};

export const geoCodingBatchEffect = (data) => {
  return axios({
    baseURL: 'https://pcmiler.alk.com/apis/rest/v1.0/service.svc/locations/address/batch',
    data,
    headers: {
      Authorization: `${ENV_VARS.REACT_APP_TRIMPLE_MAPS_API_KEY}`,
    },
    method: 'post',
  });
};

export const getPostalSearch = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetPostalSearchWithTotalCount`,
  });
};

export const getCarrierSearchWithPaginationEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetCarrierSearchWIthTotalCount`,
  });
};

export const getCarrierDetailsEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.PRIMARY}/GetCarrierDetails`,
  });
};

export const getIncortermListEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PRIMARY}/GetIncoTerm`,
  });
};

export const createSpotQuoteEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SPOT_QUOTE_V2}`,
  });
};

export const uploadQuoteDocumentEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'post',
    url: `${API.SPOT_QUOTE_V2}/documents/upload`,
  });
};

export const getNewSpotQuoteNoEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/new-quote-info`,
  });
};

export const createSpotQuoteRoutingGuideHeaderEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/header`,
  });
};

export const updateQuoteDocumentEffect = (data) => {
  return axiosInstance.request({
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'post',
    url: `${API.SPOT_QUOTE}/UpdateQuoteDocument`,
  });
};

export const deleteQuoteDocumentEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'delete',
    url: `${API.SPOT_QUOTE_V2}/documents/delete`,
  });
};

export const getSpotQuote = (quoteKey) => {
  return axiosInstance.request({
    headers: { 'Content-Type': 'application/json' },
    method: 'get',
    url: `${API.SPOT_QUOTE_V2}/${quoteKey}`,
  });
};

export const editSpotQuoteRoutingGuideHeaderEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'patch',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.id}/header`,
  });
};

export const editSpotQuoteEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'put',
    url: `${API.SPOT_QUOTE_V2}`,
  });
};

export const setSpotQuoteStatusOpenForBidEffect = (quoteKey) => {
  return axiosInstance.request({
    method: 'patch',
    params: { quoteKey },
    url: `${API.SPOT_QUOTE_V2}/statuses/set-open-for-bid`,
  });
};

export const setSpotQuoteStatusUnawardedEffect = (quoteKey, unawardedReason) => {
  return axiosInstance.request({
    method: 'patch',
    params: { quoteKey, unawardedReason },
    url: `${API.SPOT_QUOTE_V2}/statuses/set-unawarded`,
  });
};

export const putSpotQuoteCollaborator = (data) => {
  return axiosInstance.request({
    data,
    method: 'put',
    url: `${API.SPOT_QUOTE_V2}/collaborators`,
  });
};

export const putSpotQuoteBidders = (data) => {
  return axiosInstance.request({
    data,
    method: 'put',
    url: `${API.SPOT_QUOTE_V2}/carriers/bidding-carriers`,
  });
};

export const getShipmentPortList = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SHIPMENT}/GetPortSearch`,
  });
};

export const generateAwardedPreviewEffect = (params) => {
  return axiosInstance.request({
    method: 'post',
    params,
    url: `${API.SPOT_QUOTE_V2}/pdf-export`,
  });
};
